import { Card } from '@bancobarigui/barihaus';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { CompletionTrend } from '../types';
import { EmptyState } from './EmptyState';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

interface CompletionTrendChartProps {
  data: CompletionTrend[];
  loading?: boolean;
}

export function CompletionTrendChart({ data, loading = false }: CompletionTrendChartProps) {
  const chartData = {
    labels: data.map(item => item.month),
    datasets: [
      {
        label: 'Taxa de Conclusão (%)',
        data: data.map(item => item.completionRate),
        borderColor: '#1890ff',
        backgroundColor: 'rgba(24, 144, 255, 0.2)',
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context: any) {
            return `${context.parsed.y.toFixed(1).replace('.', ',')}%`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: false,
        grid: {
          display: true,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const hasData = data && data.length > 0;

  return (
    <Card title="Evolução de conclusão (comparar mês a mês)" bordered={false} loading={loading} style={{ height: '100%' }}>
      {!hasData ? (
        <EmptyState />
      ) : (
        <div style={{ height: '300px' }}>
          <Line data={chartData} options={options} />
        </div>
      )}
    </Card>
  );
}
